// File: src/config/constants.js

// System Administration
export const ADMIN_EMAIL = "support@atomicmusic.com.au";

// Fan Badge Thresholds (in Fan Points) - Aligned with Backend
export const BADGE_TIERS = {
  ULTRAFAN: { name: "UltraFan", minPoints: 25000 },
  SUPAFAN: { name: "SupaFan", minPoints: 2500 },
  FAN: { name: "Fan", minPoints: 250 },
};

// Download Unlock Threshold (Points required on a single song)
export const OFFLINE_DOWNLOAD_THRESHOLD = 50;

// Certification Award Download Count Thresholds
export const AWARD_TIERS = {
  uranium: { name: 'Uranium', downloads: 1000 },
  plutonium: { name: 'Plutonium', downloads: 100 },
  radium: { name: 'Radium', downloads: 10 },
};

export const AWARD_RANKS = { radium: 1, plutonium: 2, uranium: 3 };

/**
 * Helper utility to determine a user's badge tier string based on total points.
 * @param {number} totalPoints - Total cumulative points tipped to an artist.
 * @returns {string} Tier string ('ULTRAFAN' | 'SUPAFAN' | 'FAN' | 'NONE')
 */
export function calculateBadgeTier(totalPoints) {
  if (totalPoints >= BADGE_TIERS.ULTRAFAN.minPoints) return "ULTRAFAN";
  if (totalPoints >= BADGE_TIERS.SUPAFAN.minPoints) return "SUPAFAN";
  if (totalPoints >= BADGE_TIERS.FAN.minPoints) return "FAN";
  return "NONE";
}

export const GENRES = [
  "Pop",
  "Hip Hop",
  "Electronic",
  "Indie",
  "Alternative",
  "EDM",  
  "R&B",
  "Folk",
  "Soul",
  "Country",
  "Country Pop",
  "Indie Pop",
  "Dream Pop",
  "Pop-Punk",
  "Punk-Rock",
  "Punk",
  "Post-Punk",
  "Singer-Songwriter",
  "Acoustic",
  "Drill",
  "Trap",
  "Grime",
  "Rock",
  "Pop-Rock",
  "Classic Rock",
  "Indie Rock",
  "Alternative Rock",
  "Hard Rock",
  "Metal",
  "Dance",
  "House",
  "Jazz",
  "Neo-Jazz",
  "Classical",
  "Orchestral",
  "Reggae",
  "Electro Hip Pop",
  "Dubstep",
  "Ska",
  "Bush Ballad",
  "Worship",
  "Christian",
  "K-Pop",
  "J-Pop",
  "Afrobeats",
  "Other",
];

export const AUSTRALIAN_STATES = [
  { value: 'ACT', label: 'ACT' },
  { value: 'NSW', label: 'NSW' },
  { value: 'NT', label: 'NT' },
  { value: 'QLD', label: 'QLD' },
  { value: 'SA', label: 'SA' },
  { value: 'TAS', label: 'TAS' },
  { value: 'VIC', label: 'VIC' },
  { value: 'WA', label: 'WA' },
];